var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bar-chart',{attrs:{"chart-data":_vm.data,"title":_vm.$t('smi_sri.individual_student_sat')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }